// extracted by mini-css-extract-plugin
export default {"switchButton":"ToggleUltimateButton_switchButton__Lh+vA"};